import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import ScrollToTopComponent from './js/scroll-to-top.component';

ComponentsFactory.getInstance().define('scroll-to-top', ScrollToTopComponent);
